import { render, staticRenderFns } from "./GeneralMessage.vue?vue&type=template&id=5a0c1d2c&"
import script from "./GeneralMessage.vue?vue&type=script&lang=js&"
export * from "./GeneralMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a0c1d2c')) {
      api.createRecord('5a0c1d2c', component.options)
    } else {
      api.reload('5a0c1d2c', component.options)
    }
    module.hot.accept("./GeneralMessage.vue?vue&type=template&id=5a0c1d2c&", function () {
      api.rerender('5a0c1d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/GeneralMessage.vue"
export default component.exports